var map = {
	"./Delivered.svg": 53434,
	"./Started.svg": 55476,
	"./Transit.svg": 62278,
	"./add-to-trip-icon.svg": 85352,
	"./billed.svg": 27667,
	"./cancelled.svg": 48604,
	"./completed.svg": 79372,
	"./delay.svg": 65438,
	"./inDropLocation.svg": 9641,
	"./incomplete.svg": 37880,
	"./loading.svg": 59172,
	"./notDeliverd.svg": 59324,
	"./notDelivered.svg": 62348,
	"./pendingValidation.svg": 27202,
	"./pickUp.svg": 89151,
	"./saved.svg": 92988,
	"./unloading.svg": 831,
	"./validated.svg": 30896,
	"./vehicleAssigned.svg": 40196,
	"./waitingForTrip.svg": 64126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83547;